import { createFileRoute, Link } from "@tanstack/react-router";

import { allPages } from "@/lib/all-pages";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authenticated/admin/pages")({
  head: () => ({
    meta: [
      { title: "All Pages - RESTORE Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: AdminPages,
});

function downloadCsv() {
  const rows = ["url", ...allPages];
  const blob = new Blob([rows.join("\n")], { type: "text/csv" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "restore-hair-all-pages.csv";
  a.click();
  URL.revokeObjectURL(a.href);
}

function AdminPages() {
  return (
    <div className="mx-auto max-w-4xl px-4 py-10">
      <div className="flex items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold text-foreground">All pages</h1>
          <p className="mt-1 text-sm text-muted-foreground">
            {allPages.length} public page URLs on restorehair.com
          </p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" asChild>
            <Link to="/admin/blog">Blog</Link>
          </Button>
          <Button onClick={downloadCsv}>Export CSV</Button>
        </div>
      </div>
      <ul className="mt-8 divide-y divide-border border border-border">
        {allPages.map((url) => (
          <li key={url} className="px-4 py-2 text-sm">
            <a
              href={url}
              target="_blank"
              rel="noreferrer"
              className="text-primary hover:underline"
            >
              {url}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
